<template>
    <div>
        <div class="my_collect_list_box" v-for="(data, index) in collectData" :key="`collect${index}`" v-if="index<6">
            <div class="my_collect_img" @click="movePage(`/collect/${data.c_idx}`)">
                <img :src="returnImage(data)" alt="">
                <div class="my_collect_main_img" @click="movePage(`/collect/${data.c_idx}`)">
                    <img :src="returnMainImage(data)" width="80" height="80" alt="">
                </div>
            </div>


            <div class="my_collect_name" @click="movePage(`/collect/${data.c_idx}`)">{{
                    data.c_title
                }}
            </div>

            <div class="my_collect_text">
                <like-collection-component :like-data="data"></like-collection-component>
                <div class="collect_item_point">·</div>
                <div class="my_collect_item_cnt" @click="movePage(`/collect/${data.c_idx}`)">item
                    <span class="bold">{{ data.item_cnt }}</span></div>
                <div class="item_price" @click="movePage(`/collect/${data.c_idx}`)">
                    <div class="mingle_img"></div>
                    <span class="price">{{ returnPriceString(data.c_total) }} Mg </span>
                    <span class="item_small">({{ returnPriceStringMingle(data.c_total) }})</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import imageResizeMixins from "@/mixins/imageResizeMixins";
import priceMixins from "@/mixins/priceMixins";
import LikeCollectionComponent from "@/components/like/LikeCollectionComponent";
import util from "@/mixins/util";

export default {
    name: "CollectListSearchLayout",
    mixins: [imageResizeMixins, priceMixins],
    components: {LikeCollectionComponent},
    inject: [],
    provide() {
        return {}
    },
    props: {
        collectData: {default: () => []},
    },
    data() {
        return {}
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        movePage(url) {
            this.$router.push(url);
        },
        returnImage(data) {
            if (!util.isEmpty(data) && !util.isEmpty(data.CollectionFiles) && !util.isEmpty(data.CollectionFiles.BgFile)) {
                return `${data.CollectionFiles.BgFile[0].org_url}?${this.setImageOptions(300, 160, 'webp')}`;
            } else {
                return '';
            }
        },
        returnMainImage(data) {
            if (!util.isEmpty(data) && !util.isEmpty(data.CollectionFiles) && !util.isEmpty(data.CollectionFiles.MainFile)) {
                return `${data.CollectionFiles.MainFile[0].org_url}?${this.setImageOptions(80, 80, 'webp')}`;
            }
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
